import { metricNames } from '@linearb/linjs-common';
import { LOCAL_STORAGE_KEYS } from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { useState } from 'react';

const workBreakdownDefault = {
  newWork: '-',
  refactor: '-',
  rework: '-',
  total: '-'
};

export function useDashboardState() {
  const localStorageAccessor = BrowserStorageAccessor().local;

  const [cycleTimeStatistics, setCycleTimeStatistics] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [isNotificationsLoading, setIsNotificationsLoading] = useState(true);
  const [teamMetrics, setTeamMetrics] = useState({});
  const [teamSlackSettings, setTeamSlackSettings] = useState({});

  const [teamRetrospectData, setTeamRetrospectData] = useState({
    reviewDepth: {}
  });

  const [contributorsMetrics, setContributorsMetrics] = useState([]);
  const [contributorsBars, setContributorsBars] = useState([]);

  const [contributorsOrder, setContributorsOrder] = useState({
    by: metricNames.ACTIVE_BRANCHES,
    dir: 'desc'
  });
  const [organizationMetrics, setOrganizationMetrics] = useState({});
  const [organizationCodeChanges, setOrganizationCodeChanges] = useState({});
  const [releases, setReleases] = useState({
    emptyStateLink: '/settings/organization',
    linkText: 'Change the way releases are detected',
    descriptionText: 'Can’t see your releases?'
  });
  const [teamWorkBreakdownData, setTeamWorkBreakdownData] =
    useState(workBreakdownDefault);
  const [orgWorkBreakdownData, setOrgWorkBreakdownData] =
    useState(workBreakdownDefault);
  const [prMergedPerIteration, setPrMergedPerIteration] = useState();
  const [prOpenRate, setPrOpenRate] = useState();
  const [organizationDeploymentFrequency, setOrganizationDeploymentFrequency] =
    useState();
  const [noReleasesInIterations, setNoReleasesInIterations] = useState();
  const [closedPulseTopBar, setClosedPulseTopBar] = useState(
    !!localStorageAccessor.get(LOCAL_STORAGE_KEYS.CLOSED_PULSE_BAR)
  );

  return {
    cycleTimeStatistics,
    setCycleTimeStatistics,
    notifications,
    setNotifications,
    isNotificationsLoading,
    setIsNotificationsLoading,
    teamMetrics,
    setTeamMetrics,
    teamSlackSettings,
    setTeamSlackSettings,
    teamRetrospectData,
    setTeamRetrospectData,
    contributorsMetrics,
    setContributorsMetrics,
    contributorsOrder,
    setContributorsOrder,
    organizationMetrics,
    setOrganizationMetrics,
    organizationCodeChanges,
    setOrganizationCodeChanges,
    releases,
    setReleases,
    teamWorkBreakdownData,
    setTeamWorkBreakdownData,
    orgWorkBreakdownData,
    setOrgWorkBreakdownData,
    prMergedPerIteration,
    setPrMergedPerIteration,
    prOpenRate,
    setPrOpenRate,
    organizationDeploymentFrequency,
    setOrganizationDeploymentFrequency,
    noReleasesInIterations,
    setNoReleasesInIterations,
    closedPulseTopBar,
    setClosedPulseTopBar,
    contributorsBars,
    setContributorsBars
  };
}
